<template functional>
  <el-row>
    <el-col :span="13">
      <div class="bltr__label">{{ props.label }}:</div>
    </el-col>
    <el-col :span="11">
      <div :class="['bltr__value', props.color ? `is-${props.color}` : '']">
        {{ props.value }}
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.bltr {
  &__label {
    text-transform: uppercase;
  }
  &__value {
    text-align: right;
    font-weight: bold;

    &.is-danger {
      color: #b00;
    }
    &.is-success {
      color: #00bf40;
    }
  }
}
</style>
